import _slicedToArray from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import * as React from 'react';
import { createContext } from '~logic/lib/react';
import { jsx as _jsx } from "react/jsx-runtime";

// * CONTEXT
// as some of our apps are generic build & the branch is always decided at runtime
// we don’t know what styles (colors, texts, images) should the app be rendered with
// we need to Q the styles for some and so far there are 3 way that this can go:
//  - the branch is selected by url -> use "lookup" Q and get styles of the resolved company (eg. on HomeScreen)
//  - user is accessing data of some specific order -> use the branch associated with that order – we should have orderId as an URL param (eg. all screens past the Form screen)
// *
var _createContext = createContext("CompanyStyles"),
    _createContext2 = _slicedToArray(_createContext, 2),
    Provider = _createContext2[0],
    useCompanyStylesCtx = _createContext2[1];

/**
 * global provider of the resolved branch styles
 * use `useCompanyStylesCtx` hook to access that info anywhere in the app
 * mostly used for images/texts because colors should be taken from the theme provider (where the company ones are used as well)
 */
export var CompanyStylesProvider = function CompanyStylesProvider(_ref) {
  var children = _ref.children,
      contextValue = _ref.contextValue;
  return /*#__PURE__*/_jsx(Provider, {
    value: contextValue,
    children: children
  });
};
export { useCompanyStylesCtx };